import { render, staticRenderFns } from "./NotificationsIcon.vue?vue&type=template&id=41392e15&"
import script from "./NotificationsIcon.vue?vue&type=script&lang=js&"
export * from "./NotificationsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports